package map.views.workplacetools

import search.searchFilterStores.ActiveFieldValuesStore

class ActiveArchetypeSearchFieldValuesStore : ActiveFieldValuesStore()
